import { spawn, takeLatest, put } from 'redux-saga/effects';

// Actions
import { stepperAction } from '../../../../application/actions/stepper';


export function* fetchStepper(props) {
    const { payload } = props;
    yield put(stepperAction.fetchStepperSuccess({ posicion: payload }));
}

export function* watchFetchStepper() {
  yield takeLatest(stepperAction.fetchStepper.type, fetchStepper);
}

export default function* rootSaga() {
  yield spawn(watchFetchStepper);
}
